import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, ms: number): T {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), ms);
        return () => clearTimeout(timer);
    }, [value, ms]);

    return debouncedValue;
}
